import React from "react";
import { Alert, Snackbar } from "@mui/material";

export default function AppSnackbar({
  open,
  message,
  severity = "info",
  onClose,
  action,
  autoHideDuration = 4000,
}) {
  return (
    <Snackbar
      open={Boolean(open)}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert severity={severity || "info"} onClose={onClose} action={action} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
